// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListBox-module__Container__zabjZ {
    display: flex;
    flex-direction: column;
    gap: var(--ds-10x);
    align-items: center;
    justify-content: center;
    width: 100%;
}

.ListBox-module__Label__xxiGu {
    align-self: stretch;
}

.ListBox-module__ListBox__zPR95 {
    display: flex;
    flex-wrap: wrap;
    gap: var(--ds-s);
    align-items: flex-start;
    align-self: stretch;
}

.ListBox-module__ListBoxAlignStart__rCQGY {
    justify-content: flex-start;
}

.ListBox-module__ListBoxAlignCenter__aIb7b {
    justify-content: center;
}

.ListBox-module__ListBoxAlignEnd__QXAQn {
    justify-content: flex-end;
}

.ListBox-module__ListBoxDisabled__BG8at {
    pointer-events: none;
}

.ListBox-module__OtherFieldContainer__lJJv2 {
    width: 100%;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `ListBox-module__Container__zabjZ`,
	"Label": `ListBox-module__Label__xxiGu`,
	"ListBox": `ListBox-module__ListBox__zPR95`,
	"ListBoxAlignStart": `ListBox-module__ListBoxAlignStart__rCQGY`,
	"ListBoxAlignCenter": `ListBox-module__ListBoxAlignCenter__aIb7b`,
	"ListBoxAlignEnd": `ListBox-module__ListBoxAlignEnd__QXAQn`,
	"ListBoxDisabled": `ListBox-module__ListBoxDisabled__BG8at`,
	"OtherFieldContainer": `ListBox-module__OtherFieldContainer__lJJv2`
};
export default ___CSS_LOADER_EXPORT___;
